<template>
	<div class="sliderScreeningPage">
		<div class="sliderScreening">
			<div class="sliderScreeningCC">
				<span class="text">创建时间</span>
				<div class="sliderScreeningR">
					<el-date-picker
			         class="sliderDataCls sliderDataClsMonth"
					 ref="datePickers"
			          v-model="setDateArr.data"
			          type="monthrange"
			           @change="datePicker"
					   @blur="minDate = ''"
					   :picker-options="pickerOptions"
			           size="mini"
			          range-separator="~"
			          value-format="yyyy/MM" format='yyyy-MM'
			          start-placeholder="开始时间"
			          end-placeholder="结束时间">
			        </el-date-picker>
				</div>
			</div>
			<div class="sliderScreeningCC">
				<span class="text">医生类型</span>
				<div class="sliderScreeningR">
					<a href="javascript:;" @click="HospitalAVGScoreArrType(2)" :class="HospitalAVGScoreArr.type==2?'active':''">审核医生</a>
					<a href="javascript:;" class="marr1" @click="HospitalAVGScoreArrType(3)" :class="HospitalAVGScoreArr.type==3?'active':''">影像技师</a>
					<a href="javascript:;" @click="HospitalAVGScoreArrType(4)" :class="HospitalAVGScoreArr.type==4?'active':''">诊断医生</a>
				</div>
			</div>
			<div class="sliderScreeningCC">
				<span class="text">报告条件</span>
				<div class="sliderScreeningR">
					<a href="javascript:;" @click="institutionBtn('average')" :class="HospitalAVGScoreBtn.average?'active':''">平均分</a>
					<a href="javascript:;" @click="institutionBtn('deduct')" :class="HospitalAVGScoreBtn.deduct?'active':''">不合格</a>
				</div>
			</div>
			<div class="sliderScreeningCC" v-if="trigger.regions&&zoneBtn.type">
				<span class="text">排名类型</span>
				<div class="sliderScreeningR">
					<a href="javascript:;" @click="institutionArea(false)" :class="!trigger.regionsData?'active':''">影像中心</a>
					<a href="javascript:;" @click="institutionArea(true)" :class="trigger.regionsData?'active':''">区域排名</a>
				</div>
			</div>
			<!--<div class="sliderScreeningCC">
				<span class="text marl40">排序方式</span>
				<div class="sliderScreeningR">
					<a href="javascript:;" @click="institutionSort(2)" :class="sortOrderType==2?'active':''">由高到低</a>
					<a href="javascript:;" @click="institutionSort(1)" :class="sortOrderType==1?'active':''">由低到高</a>
				</div>
			</div>-->

		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import date from '@/js/date.js'
	export default {
		data() {
			return {
				minDate: ''
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['SummaryArr','DoctorsAvgScoreName','HospitalAVGScoreName','loading','setDateArr','slider','setDate','InstitutionalRanking', 'HospitalAVGScore', 'trigger', 'HospitalAVGScores', 'HospitalAVGScoreBtn', 'HospitalAVGScoreArr', 'DoctorsAvgScoreArr', 'treeDefault', 'InitUniqueId', 'isShowEcharts', 'HospitalAVGTypeName','zoneBtn','sortOrderType']),
			pickerOptions(){
				let _this = this;
				return{
					onPick({ maxDate, minDate }) {
						if (!maxDate) {
							_this.minDate = minDate;
							_this.$refs.datePickers.$el.children[1].value = date.mouthformat(minDate,'-');
						}
					},
					disabledDate(time) {
						return new Date(_this.minDate).getTime() > time.getTime();
					}
				}
			},
		},
		methods: {
			...Vuex.mapMutations('supervisor', ['setLoading','setDateArrMu','setHospitalAVGScoreBtn','zoneBtnChange','sortOrderTypeChange']),
			...Vuex.mapActions('supervisor', ['GetHospitalAVGScore', 'GetHospitalUnqualifiedReport', 'GetDoctorsAvgScore', 'GetDoctorUnqualifiedReport', 'GetReportList', 'GetRegionAVGScore', 'GetRegionUnqualifiedReport','GetSummary','GetCount']),
			//时间选择
			datePicker(event){
				this.DoctorsAvgScoreArr.pageIndex = 1;
				this.setDate.startdt = this.setDateArr.data[0];
				this.setDate.enddt = this.setDateArr.data[1];
				this.defaultGet();
				this.GetSummary();
				this.GetCount();
			},
			//机构排序
			institutionSort(arr) {
				this.setLoading(true);
				this.sortOrderTypeChange(arr);
				this.HospitalAVGScoreArr.sortType = arr;
				this.defaultGet()
			},
			//按钮切换
			institutionBtn(arr) {
				this.HospitalAVGScoreName.condition = this.DoctorsAvgScoreName.condition = arr=='average'? '平均分' : '不合格';
				this.DoctorsAvgScoreArr.pageIndex = 1;
				this.setLoading(true);
				this.setHospitalAVGScoreBtn(arr);
				this.defaultGet()
			},
			//技师报告切换
			HospitalAVGScoreArrType(arr) {
				this.DoctorsAvgScoreArr.pageIndex = 1;
				this.setLoading(true);
				this.HospitalAVGScoreArr.type = arr;
				this.HospitalAVGTypeName.name = arr;
				switch (arr) {
					case 2 :
						this.DoctorsAvgScoreName.type = '审核医生';
						break;
					case 3 :
						this.DoctorsAvgScoreName.type = '影像技师';
						break;
					case 4 :
						this.DoctorsAvgScoreName.type = '诊断医生';
						break;
					default :
					    this.DoctorsAvgScoreName.type = '医生';
				}
				this.SummaryArr.type = arr;
				this.defaultGet();
				this.GetSummary();
				this.GetCount();
				// this.HospitalAVGScoreName.type = this.DoctorsAvgScoreName.type = arr==2||arr==4? '医生' : '技师';
			},
			//区域排名
			institutionArea(arr) {
				this.setLoading(true);
				if(arr) {
					this.isShowEcharts.hospital = true;
					this.HospitalAVGScoreName.region = '区域';
				}else{
					this.HospitalAVGScoreName.region = '影像中心';
				}
				this.trigger.regionsData = arr;
				this.defaultGet();

			},
			defaultGet() {
				this.HospitalAVGScoreName.makeUp = this.HospitalAVGScoreName.name + this.HospitalAVGScoreName.region + this.HospitalAVGScoreName.condition + this.HospitalAVGScoreName.rank;
				this.DoctorsAvgScoreName.makeUp = this.DoctorsAvgScoreName.name + this.DoctorsAvgScoreName.type +  this.DoctorsAvgScoreName.condition + this.DoctorsAvgScoreName.rank;
				this.DoctorsAvgScoreArr.pageIndex = 1;
				// this.treeDefault.checked = this.InitUniqueId;
				//区域排名
				if(this.trigger.regionsData) {
					this.DoctorsAvgScoreArr.hospitalGuid = '';
					this.HospitalAVGScoreArr.regionId = this.InitUniqueId;
					this.defaultDoctorGet();
				} else {
					if(this.HospitalAVGScoreBtn.average) {
						this.GetHospitalAVGScore();
						this.GetDoctorsAvgScore();
					}
					if(this.HospitalAVGScoreBtn.deduct) {
						this.GetHospitalUnqualifiedReport();
						this.GetDoctorUnqualifiedReport();
					}
				}
				
			},
			defaultDoctorGet() {
				if(this.HospitalAVGScoreBtn.average) {
					this.GetRegionAVGScore();
					this.GetDoctorsAvgScore();
				}
				if(this.HospitalAVGScoreBtn.deduct) {
					this.GetDoctorUnqualifiedReport();
					this.GetRegionUnqualifiedReport();
				}
			},
		}

	}
</script>